(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-colorway-viewer"] && !Shopify.designMode) return;
  try {
    
  class CrColorwayViewer extends HTMLElement {
    #index = 0;

    connectedCallback() {
      this.frames = [...this.querySelectorAll('.cr-viewer__frame')];
      this.swatches = [...this.querySelectorAll('.cr-viewer__swatch')];
      this.nameEl = this.querySelector('[data-viewer-name]');
      this.priceEl = this.querySelector('[data-viewer-price]');
      this.linkEl = this.querySelector('[data-viewer-link]');
      this.addEl = this.querySelector('[data-viewer-add]');
      this.statusEl = this.querySelector('[data-viewer-status]');
      if (!this.frames.length) return;

      for (const swatch of this.swatches) {
        swatch.addEventListener('click', () => this.#select(Number(swatch.dataset.index)));
        swatch.addEventListener('keydown', this.#onKey.bind(this));
      }

      this.viewButtons = [...this.querySelectorAll('[data-view]')];
      for (const button of this.viewButtons) {
        button.addEventListener('click', () => this.#setView(button.dataset.view));
      }

      this.#bindSwipe();
      this.#select(0, { announce: false });
      this.#setView('front');
    }

    #onKey(event) {
      const last = this.swatches.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = this.#index === last ? 0 : this.#index + 1;
      if (event.key === 'ArrowLeft') next = this.#index === 0 ? last : this.#index - 1;
      if (next === null) return;
      event.preventDefault();
      this.#select(next);
      this.swatches[next].focus();
    }

    // Swipe the frame area on touch devices.
    #bindSwipe() {
      const stage = this.querySelector('.cr-viewer__frames');
      if (!stage) return;
      let startX = null;
      stage.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );
      stage.addEventListener(
        'touchend',
        (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) < 40) return;
          const last = this.swatches.length - 1;
          const next =
            dx < 0 ? (this.#index === last ? 0 : this.#index + 1) : this.#index === 0 ? last : this.#index - 1;
          this.#select(next);
        },
        { passive: true }
      );
    }

    #setView(view) {
      this.view = view;
      for (const button of this.viewButtons) {
        button.classList.toggle('is-current', button.dataset.view === view);
      }
      for (const shot of this.querySelectorAll('.cr-viewer__shot')) {
        shot.classList.toggle('is-shown', shot.classList.contains(`cr-viewer__shot--${view}`));
      }
    }

    #select(index, { announce = true } = {}) {
      const swatch = this.swatches[index];
      if (!swatch) return;
      this.#index = index;

      this.frames.forEach((frame, i) => {
        const on = i === index;
        frame.classList.toggle('is-active', on);
        if (on) frame.removeAttribute('aria-hidden');
        else frame.setAttribute('aria-hidden', 'true');
      });

      this.swatches.forEach((s, i) => {
        s.classList.toggle('is-current', i === index);
        s.setAttribute('aria-selected', String(i === index));
      });

      const { name, price, url, variant } = swatch.dataset;
      if (this.nameEl) this.nameEl.textContent = name || '';
      if (this.priceEl) this.priceEl.textContent = price || '';
      if (this.linkEl && url) this.linkEl.href = url;
      if (this.addEl && variant) this.addEl.dataset.variantId = variant;

      if (announce && this.statusEl) {
        this.statusEl.textContent = '';
        requestAnimationFrame(() => {
          this.statusEl.textContent = `${name} selected`;
        });
      }
    }
  }

  customElements.define('cr-colorway-viewer', CrColorwayViewer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-creator-grid"] && !Shopify.designMode) return;
  try {
    
  // Five autoplaying videos is a lot to ask of a phone. Load and play only what
  // is actually on screen, and pause the rest.
  class CrCreatorGrid extends HTMLElement {
    connectedCallback() {
      this.#enableDesktopDrag();
      this.videos = [...this.querySelectorAll('video')];
      if (!this.videos.length) return;

      if (this.dataset.autoplay === 'false') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.observer = new IntersectionObserver(this.#onIntersect.bind(this), {
        rootMargin: '150px',
        threshold: 0.25,
      });
      for (const video of this.videos) this.observer.observe(video);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #enableDesktopDrag() {
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let dragged = false;

      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = this.scrollLeft;
        dragged = false;
      });

      this.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5) {
          if (!dragged) this.setPointerCapture(event.pointerId);
          dragged = true;
          this.classList.add('is-dragging');
          this.scrollLeft = startScrollLeft - distance;
        }
      });

      this.addEventListener('pointerup', (event) => {
        if (event.pointerId !== pointerId) return;
        if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        pointerId = null;
        this.classList.remove('is-dragging');
      });

      this.addEventListener('pointercancel', (event) => {
        if (event.pointerId !== pointerId) return;
        if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        pointerId = null;
        dragged = false;
        this.classList.remove('is-dragging');
      });

      this.addEventListener(
        'click',
        (event) => {
          if (!dragged) return;
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        },
        true
      );
    }

    #onIntersect(entries) {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.preload !== 'auto') video.preload = 'auto';
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    }
  }

  customElements.define('cr-creator-grid', CrCreatorGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-offer-popup"] && !Shopify.designMode) return;
  try {
    
  class CrOfferPopup extends HTMLElement {
    #timer = null;

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.storageKey = this.dataset.storageKey || 'cr-offer-dismissed';
      this.rememberDays = Number(this.dataset.rememberDays) || 30;

      // Theme editor: always show so the merchant can style it.
      if (window.Shopify && window.Shopify.designMode) {
        this.dialog.showModal();
        this.#bindClose();
        return;
      }

      if (this.#recentlyDismissed()) return;

      const delay = Number(this.dataset.delay) || 8000;
      this.#timer = setTimeout(() => this.#open(), delay);
      this.#bindClose();
    }

    disconnectedCallback() {
      if (this.#timer) clearTimeout(this.#timer);
    }

    #bindClose() {
      for (const button of this.querySelectorAll('[data-offer-close]')) {
        button.addEventListener('click', () => this.#dismiss());
      }
      this.dialog.addEventListener('click', (event) => {
        const bounds = this.dialog.getBoundingClientRect();
        const clickedOutside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (clickedOutside) this.#dismiss();
      });
      this.dialog.addEventListener('close', () => this.#remember());
    }

    #open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    #dismiss() {
      this.#remember();
      if (this.dialog.open) this.dialog.close();
    }

    #remember() {
      try {
        localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (error) {
        // Private browsing or blocked storage - popup simply shows again next visit.
      }
    }

    #recentlyDismissed() {
      try {
        const stamp = Number(localStorage.getItem(this.storageKey));
        if (!stamp) return false;
        const ageDays = (Date.now() - stamp) / 86400000;
        return ageDays < this.rememberDays;
      } catch (error) {
        return false;
      }
    }
  }

  customElements.define('cr-offer-popup', CrOfferPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-split-editorial-halves"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cr-split-product-swiper')) {
    customElements.define(
      'cr-split-product-swiper',
      class extends HTMLElement {
        connectedCallback() {
          let pointerId = null;
          let startX = 0;
          let startScroll = 0;
          let dragged = false;

          this.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            if (event.target.closest('button')) return;
            pointerId = event.pointerId;
            startX = event.clientX;
            startScroll = this.scrollLeft;
            dragged = false;
          });

          this.addEventListener('pointermove', (event) => {
            if (event.pointerId !== pointerId) return;
            const distance = event.clientX - startX;
            if (Math.abs(distance) > 5) {
              dragged = true;
              this.setPointerCapture(event.pointerId);
              this.classList.add('is-dragging');
              event.preventDefault();
              this.scrollLeft = startScroll - distance;
            }
          });

          const stop = (event) => {
            if (event.pointerId !== pointerId) return;
            if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
            pointerId = null;
            this.classList.remove('is-dragging');
            setTimeout(() => {
              dragged = false;
            }, 0);
          };

          this.addEventListener('pointerup', stop);
          this.addEventListener('pointercancel', stop);
          this.addEventListener(
            'click',
            (event) => {
              if (!dragged) return;
              event.preventDefault();
              event.stopPropagation();
              dragged = false;
            },
            true
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class CrAnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('cr-ann-bar--rotating')) return;

      this.messages = [...this.querySelectorAll('.cr-ann-bar__msg')];
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.resume = this.start.bind(this);
      this.stopTimer = this.stop.bind(this);

      if (this.messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.addEventListener('mouseenter', this.stopTimer);
      this.addEventListener('mouseleave', this.resume);
      this.addEventListener('focusin', this.stopTimer);
      this.addEventListener('focusout', this.resume);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.advance(), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    advance() {
      const previous = this.messages[this.index];
      this.index = (this.index + 1) % this.messages.length;
      const next = this.messages[this.index];

      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
    }
  }

  if (!customElements.get('cr-announcement-bar')) {
    customElements.define('cr-announcement-bar', CrAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
